/**
 * UI strings for the public EAM Music Support Hub (/help).
 * Article content itself lives in src/lib/supportHubContent.js.
 */
const supportHub = {
  en: {
    "hub.brand": "Support Hub",
    "hub.metaTitle": "EAM Music Support Hub",
    "hub.tagline": "Music support for artists and labels",
    "hub.login": "Log in",
    "hub.getStarted": "Get Started",
    "hub.dashboard": "Dashboard",
    "hub.language": "Language",
    "hub.skipToContent": "Skip to content",
    "hub.heroEyebrow": "EAM Music Support Hub",
    "hub.heroTitle": "How can we help you?",
    "hub.heroSubtitle": "Answers about distribution, payments, accounts and promotion — straight from the EAM Music team.",
    "hub.searchLabel": "Search the Support Hub",
    "hub.searchPlaceholder": "Ask us something… e.g. payout, ISRC, cover song",
    "hub.searchPlaceholderShort": "Search articles…",
    "hub.searchClear": "Clear search",
    "hub.searchNoResults": "No articles match “{q}”.",
    "hub.searchNoResultsHint": "Try different words, or open a ticket and we'll help you directly.",
    "hub.searchResultsCount": "{n} results",
    "hub.searchHint": "↑↓ to navigate · Enter to open",
    "hub.tryLabel": "Try:",
    "hub.suggestions": "Payout,ISRC,Cover song,Takedown,Label plan",
    "hub.breadcrumb": "Breadcrumb",
    "hub.browseCategories": "Browse categories",
    "hub.browseCategoriesDesc": "Pick a topic to see every answer in it.",
    "hub.articlesCount": "{n} articles",
    "hub.viewAll": "View all",
    "hub.startHere": "Start here",
    "hub.startHereDesc": "The essentials for new EAM Music artists.",
    "hub.home": "Support Hub",
    "hub.inThisCategory": "In this category",
    "hub.relatedArticles": "Related articles",
    "hub.wasHelpful": "Was this article helpful?",
    "hub.yes": "Yes",
    "hub.no": "No",
    "hub.thanksYes": "Thanks for your feedback!",
    "hub.thanksNo": "Sorry this didn't help. Our team can answer your question directly.",
    "hub.changeVote": "Change answer",
    "hub.stillNeedHelp": "Still need help?",
    "hub.stillNeedHelpDesc": "Our support team reads every message. Tell us what's going on and we'll get back to you.",
    "hub.openTicket": "Open a ticket",
    "hub.emailUs": "E-mail support",
    "hub.notFoundTitle": "We couldn't find that page",
    "hub.notFoundDesc": "The article may have moved. Try searching or browse the categories.",
    "hub.backToHub": "Back to Support Hub",
    "hub.backTo": "Back to {category}",
    "hub.footerRights": "All rights reserved.",
    "hub.footerContact": "Contact",
    "support.openHub": "Support Hub",
  },
  tr: {
    "hub.brand": "Support Hub",
    "hub.metaTitle": "EAM Music Support Hub",
    "hub.tagline": "Sanatçılar ve plak şirketleri için müzik desteği",
    "hub.login": "Giriş Yap",
    "hub.getStarted": "Hemen Başla",
    "hub.dashboard": "Panel",
    "hub.language": "Dil",
    "hub.skipToContent": "İçeriğe geç",
    "hub.heroEyebrow": "EAM Music Support Hub",
    "hub.heroTitle": "Sana nasıl yardımcı olabiliriz?",
    "hub.heroSubtitle": "Dağıtım, ödemeler, hesap ve tanıtım hakkındaki yanıtlar doğrudan EAM Music ekibinden.",
    "hub.searchLabel": "Support Hub'da ara",
    "hub.searchPlaceholder": "Bize bir şey sor… ör. ödeme, ISRC, cover şarkı",
    "hub.searchPlaceholderShort": "Makalelerde ara…",
    "hub.searchClear": "Aramayı temizle",
    "hub.searchNoResults": "“{q}” ile eşleşen makale bulunamadı.",
    "hub.searchNoResultsHint": "Farklı kelimeler dene ya da destek talebi oluştur; sana doğrudan yardımcı olalım.",
    "hub.searchResultsCount": "{n} sonuç",
    "hub.searchHint": "↑↓ ile gezin · Enter ile aç",
    "hub.tryLabel": "Örnek:",
    "hub.suggestions": "Ödeme,ISRC,Cover şarkı,Kaldırma,Label planı",
    "hub.breadcrumb": "Sayfa yolu",
    "hub.browseCategories": "Kategorilere göz at",
    "hub.browseCategoriesDesc": "Bir konu seç, o konudaki tüm yanıtları gör.",
    "hub.articlesCount": "{n} makale",
    "hub.viewAll": "Tümünü gör",
    "hub.startHere": "Buradan başla",
    "hub.startHereDesc": "Yeni EAM Music sanatçıları için temel bilgiler.",
    "hub.home": "Support Hub",
    "hub.inThisCategory": "Bu kategoride",
    "hub.relatedArticles": "İlgili makaleler",
    "hub.wasHelpful": "Bu makale işine yaradı mı?",
    "hub.yes": "Evet",
    "hub.no": "Hayır",
    "hub.thanksYes": "Geri bildirimin için teşekkürler!",
    "hub.thanksNo": "Yardımcı olamadığımız için üzgünüz. Ekibimiz sorunu doğrudan yanıtlayabilir.",
    "hub.changeVote": "Yanıtı değiştir",
    "hub.stillNeedHelp": "Hâlâ yardıma mı ihtiyacın var?",
    "hub.stillNeedHelpDesc": "Destek ekibimiz her mesajı okur. Neler olduğunu anlat, sana dönüş yapalım.",
    "hub.openTicket": "Destek talebi oluştur",
    "hub.emailUs": "E-posta gönder",
    "hub.notFoundTitle": "Bu sayfayı bulamadık",
    "hub.notFoundDesc": "Makale taşınmış olabilir. Arama yapmayı dene ya da kategorilere göz at.",
    "hub.backToHub": "Support Hub'a dön",
    "hub.backTo": "{category} bölümüne dön",
    "hub.footerRights": "Tüm hakları saklıdır.",
    "hub.footerContact": "İletişim",
    "support.openHub": "Support Hub",
  },
  es: {
    "hub.brand": "Support Hub",
    "hub.metaTitle": "EAM Music Support Hub",
    "hub.tagline": "Soporte musical para artistas y sellos",
    "hub.login": "Iniciar sesión",
    "hub.getStarted": "Empezar",
    "hub.dashboard": "Panel",
    "hub.language": "Idioma",
    "hub.skipToContent": "Saltar al contenido",
    "hub.heroEyebrow": "EAM Music Support Hub",
    "hub.heroTitle": "¿Cómo podemos ayudarte?",
    "hub.heroSubtitle": "Respuestas sobre distribución, pagos, cuentas y promoción, directamente del equipo de EAM Music.",
    "hub.searchLabel": "Buscar en el Support Hub",
    "hub.searchPlaceholder": "Pregúntanos algo… p. ej. pagos, ISRC, versiones",
    "hub.searchPlaceholderShort": "Buscar artículos…",
    "hub.searchClear": "Borrar búsqueda",
    "hub.searchNoResults": "Ningún artículo coincide con “{q}”.",
    "hub.searchNoResultsHint": "Prueba con otras palabras o abre un ticket y te ayudaremos directamente.",
    "hub.searchResultsCount": "{n} resultados",
    "hub.searchHint": "↑↓ para navegar · Enter para abrir",
    "hub.tryLabel": "Prueba:",
    "hub.suggestions": "Pagos,ISRC,Versiones,Retirada,Plan Label",
    "hub.breadcrumb": "Ruta de navegación",
    "hub.browseCategories": "Explorar categorías",
    "hub.browseCategoriesDesc": "Elige un tema para ver todas sus respuestas.",
    "hub.articlesCount": "{n} artículos",
    "hub.viewAll": "Ver todo",
    "hub.startHere": "Empieza aquí",
    "hub.startHereDesc": "Lo esencial para nuevos artistas de EAM Music.",
    "hub.home": "Support Hub",
    "hub.inThisCategory": "En esta categoría",
    "hub.relatedArticles": "Artículos relacionados",
    "hub.wasHelpful": "¿Te ha resultado útil este artículo?",
    "hub.yes": "Sí",
    "hub.no": "No",
    "hub.thanksYes": "¡Gracias por tu opinión!",
    "hub.thanksNo": "Sentimos que no te haya ayudado. Nuestro equipo puede responderte directamente.",
    "hub.changeVote": "Cambiar respuesta",
    "hub.stillNeedHelp": "¿Sigues necesitando ayuda?",
    "hub.stillNeedHelpDesc": "Nuestro equipo de soporte lee todos los mensajes. Cuéntanos qué ocurre y te responderemos.",
    "hub.openTicket": "Abrir un ticket",
    "hub.emailUs": "Escribir al soporte",
    "hub.notFoundTitle": "No hemos encontrado esa página",
    "hub.notFoundDesc": "Puede que el artículo se haya movido. Prueba a buscar o explora las categorías.",
    "hub.backToHub": "Volver al Support Hub",
    "hub.backTo": "Volver a {category}",
    "hub.footerRights": "Todos los derechos reservados.",
    "hub.footerContact": "Contacto",
    "support.openHub": "Support Hub",
  },
};

export default supportHub;
